import { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { formatarValor, formatarValorAPI, getCurrentUser } from '../../common/utils';

class AgendamentosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.situacoes = [
            {value: 'solicitado', label: 'Solicitado'},
            {value: 'liberado', label: 'Liberado'},
            {value: 'em_analise', label: 'Em analise'},
            {value: 'finalizado', label: 'Finalizado'},
            {value: 'cancelado', label: 'Cancelado'},
        ];

        this.state = {
            data_agendamento: '',
            data_liberacao: '',
            data_realizacao: '',
            beneficiario_id: '',
            beneficiario_nome: '',
            prestador_id: '',
            prestador_nome: '',
            mentorado_id: '',
            mentorado_nome: '',
            cliente_id: '',
            cliente_nome: '',
            programa_id: '',
            programa_nome: '',
            valor: '',
            nfe: '',
            servico_procedimento_id: '',
            servico_procedimento_nome: '',
            situacao: 'liberado',
            situacao_nome: 'Liberado',
            mentoria: true,
            possui_chamada_video: true,
            dados_beneficiario: Object,
            dados_prestador: Object,
            dados_servico_procedimento: Object,
            erroLoadRegistro: "",
            agendamento_id: "",
            titulo_pagina: "",
            meeting_room_id: "",
            meeting_host_url: "",
            meeting_guest_url: "",
            loading: false,
            dataAgendamentoHelper: '',
            dataLiberacaoHelper: '',
            dataRealizacaoHelper: '',
            BeneficiarioIdHelper: '',
            PrestadorIdHelper: '', 
            ValorHelper: '',
            NfeHelper: '',
            ServicoProcedimentoIdHelper: '',
            SituacaoHelper: '',
            key: 0,
            data_solicitacao: '',
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        this.setState({
            agendamento_id: id,
            loading: true,
            erroLoadRegistro: ''
        })

        if(id){
            //consulta os dados do agendamento na api
            api.get(`/agendamentos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    data_agendamento: dados.data_agendamento,
                    data_liberacao: dados.data_liberacao || '',
                    data_realizacao: dados.data_realizacao || '',
                    beneficiario_id: dados.beneficiario_id,
                    beneficiario_nome: dados.dados_beneficiario.nome,
                    prestador_id: dados.prestador_id,
                    prestador_nome: dados.dados_prestador.nome,
                    cliente_id: dados.cliente_id,
                    cliente_nome: dados.dados_cliente.nome,
                    programa_id: dados.programa_id,
                    programa_nome: dados.dados_programa.nome,
                    mentorado_id: dados.mentorado_id,
                    mentorado_nome: dados.dados_mentorado.nome,
                    valor: formatarValor(dados.valor),
                    nfe: dados.nfe || '',
                    servico_procedimento_id: dados.servico_procedimento_id,
                    servico_procedimento_nome: dados.dados_servico_procedimento.nome,
                    situacao: dados.situacao || '',
                    situacao_nome: (dados.situacao) ? this.getSituacaoLabel(dados.situacao) : '',
                    dados_beneficiario: dados.dados_beneficiario,
                    dados_prestador: dados.dados_prestador,
                    dados_servico_procedimento: dados.dados_servico_procedimento,
                    mentoria: dados.mentoria,
                    possui_chamada_video: dados.possui_chamada_video,
                    loading: false,
                    titulo_pagina: 'Editando Agendamento: ' + dados.dados_beneficiario.nome,
                    meeting_room_id: dados.dados_meeting?.whereby_sala_id,
                    meeting_host_url: dados.dados_meeting?.whereby_sala_host_url,
                    meeting_guest_url: dados.dados_meeting?.whereby_sala_url,
                    data_solicitacao: dados.data_solicitacao || '',
                })                
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar agendamento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                carteira_id: '',
                titulo_pagina: 'Adicionar Agendamento',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            dataAgendamentoHelper: '',
            dataLiberacaoHelper: '',
            dataRealizacaoHelper: '',
            BeneficiarioIdHelper: '',
            PrestadorIdHelper: '',
            ValorHelper: '',
            NfeHelper: '',
            ServicoProcedimentoIdHelper: '',
            SituacaoHelper: '',
        });

        //verifica se é edição ou adição
        const url = (this.state.agendamento_id) ? '/agendamentos/'+this.state.agendamento_id+'/' : '/agendamentos/';
        const metodo = (this.state.agendamento_id) ? 'put' : 'post';

        const valorFormatadoAPI = formatarValorAPI(this.state.valor);

        formData.append('data_agendamento', this.state.data_agendamento);
        formData.append('data_liberacao', this.state.data_liberacao);
        formData.append('data_realizacao', this.state.data_realizacao);
        formData.append('cliente_id', this.state.cliente_id);
        formData.append('programa_id', this.state.programa_id);
        
        if(this.state.beneficiario_id) {
            formData.append('beneficiario_id', this.state.beneficiario_id);
        }
        
        formData.append('mentorado_id', this.state.mentorado_id);
        formData.append('prestador_id', this.state.prestador_id);
        formData.append('valor', valorFormatadoAPI);
        formData.append('nfe', this.state.nfe);
        formData.append('servico_procedimento_id', this.state.servico_procedimento_id);
        formData.append('situacao', this.state.situacao);
        formData.append('mentoria', this.state.mentoria);
        formData.append('possui_chamada_video', this.state.possui_chamada_video);
        formData.append('data_solicitacao', this.state.data_solicitacao);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.agendamento_id) ? 'Agendamento atualizado com sucesso' : 'Agendamento cadastrado com sucesso';

            const id_agendamento = (this.state.agendamento_id) ? this.state.agendamento_id : response.data.id;

            // Calcula nova data de agendamento + 2 dias
            let dataAgendamento = new Date(this.state.data_agendamento);
            dataAgendamento.setDate(dataAgendamento.getDate() + 2);
            let dataAgendamentoFormatada = dataAgendamento.toISOString().split('T')[0]; // Formato YYYY-MM-DD

            if(this.state.possui_chamada_video) {
                api.post('/meetings/', {
                    agendamento_id: response.data.id, // Ajuste conforme a resposta da sua API
                    minutos_expiracao: 5000
                })
                .then(responseSala => {
                    this.setState({
                        loading: false,
                        meeting_guest_url: responseSala.data.whereby_sala_url,
                        meeting_host_url: responseSala.data.whereby_sala_host_url,
                        meeting_room_id: responseSala.data.whereby_sala_id,
                    })

                    MySwal.fire({
                        title: 'Agendamento Criado',
                        icon: 'success',
                        html: 'Agendamento criado com sucesso',
                        showCloseButton: true,
                    }).then((result) => {
                        //redireciona
                        if(!id_agendamento){
                            this.props.router.navigate("/agendamentos");
                        } else {
                            window.location.href = `/agendamentos/edit/${id_agendamento}`;
                        }
                    });
                })
                .catch(errorSala => {
                    this.setState({
                        loading: false,
                    })

                    // Exibir mensagem de erro sobre criação da sala
                    MySwal.fire({
                        icon: 'warning',
                        title: 'Atenção!',
                        html: '<p>Agendamento criado, porém houve um erro para criar a sala, tente novamente através do botão Criar Sala</p>',
                        showCloseButton: true,
                    }).then((result) => {
                        //redireciona
                        if(!id_agendamento){
                            this.props.router.navigate("/agendamentos");
                        } else {
                            window.location.href = `/agendamentos/edit/${id_agendamento}`;
                        }
                    });
                });
            } else {
                this.setState({
                    loading: false,
                })

                MySwal.fire({
                    title: 'Agendamento Criado',
                    icon: 'success',
                    html: 'Agendamento criado com sucesso',
                    showCloseButton: true,
                }).then((result) => {
                    //redireciona
                    if(!id_agendamento){
                        this.props.router.navigate("/agendamentos");
                    } else {
                        window.location.href = `/agendamentos/edit/${id_agendamento}`;
                    }
                });
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o agendamento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'data_agendamento'){
                        this.setState({ dataAgendamentoHelper: value })
                    }
                    if(key === 'data_liberacao'){
                        this.setState({ dataLiberacaoHelper: value })
                    }
                    if(key === 'data_realizacao'){
                        this.setState({ dataRealizacaoHelper: value })
                    }
                    if(key === 'beneficiario_id'){
                        this.setState({ BeneficiarioIdHelper: value })
                    }
                    if(key === 'prestador_id'){
                        this.setState({ PrestadorIdHelper: value })
                    }
                    if(key === 'valor'){
                        this.setState({ ValorHelper: value })
                    }
                    if(key === 'nfe'){
                        this.setState({ NfeHelper: value })
                    }
                    if(key === 'servico_procedimento_id'){
                        this.setState({ ServicoProcedimentoIdHelper: value })
                    }
                    if(key === 'situacao'){
                        this.setState({ SituacaoHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'beneficiario_id') {
            this.setState({ beneficiario_id: event.value, beneficiario_nome: event.label });
        }
        if(fieldName == 'prestador_id') {
            this.setState({ prestador_id: event.value, prestador_nome: event.label });
        }
        else if(fieldName == 'mentorado_id') {
            this.setState({ mentorado_id: event.value, mentorado_nome: event.label });
        }
        else if (fieldName == "servico_procedimento_id") {
            this.setState({ servico_procedimento_id: event.value, servico_procedimento_nome: event.label });
        }
        else if (fieldName == "situacao") {
            this.setState({ situacao: event.value, situacao_nome: event.label });
        }
        else if (fieldName == "valor") {
            const { name, value } = event.target;
            this.setState({ [name]: formatarValor(value) });
        }
        else if (fieldName == "cliente_id") {
            this.setState({ cliente_id: event.value, cliente_nome: event.label });
        }
        else if (fieldName == "programa_id") {
            this.setState({ programa_id: event.value, programa_nome: event.label });
        } else if (fieldName === 'mentoria') {
            this.setState(prevState => ({
                mentoria: event,
                key: prevState.key + 1  // Atualize a chave
            }), () => {
                this.resetSelects();
            });
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    resetSelects = () => {
        this.setState({
            prestador_id: '',
            mentorado_id: ''
        });
    };

    carregaBeneficiarios = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/beneficiarios/?nome=${inputValue}`);
            const opcoes = response.data.results.map(beneficiario => ({
                value: beneficiario.id,
                label: beneficiario.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar beneficiários:', error);
            return [];
        }
    };

    carregaPrestadores = async (inputValue) => {
        try {
            const dados_usuario = getCurrentUser();
            const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.programa_id}&tipo_usuario=${dados_usuario.tipo_usuario}`);
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.id,
                label: prestador.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    carregaMentores = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.programa_id}&mentor=1`);
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.id,
                label: prestador.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar mentores:', error);
            return [];
        }
    };

    carregaMentorados = async (inputValue) => {
        console.log("Mentorados");
        try {
            const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.programa_id}`);
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.id,
                label: prestador.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar mentorados:', error);
            return [];
        }
    };

    carregaServicoProcedimento = async (inputValue) => {
        try {
            const response = await api.get(`/servicos_procedimentos/?nome=${inputValue}`);
            const opcoes = response.data.results.map(servico => ({
                value: servico.id,
                label: servico.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar serviço/procedimento:', error);
            return [];
        }
    };

    getSituacaoLabel(key) {
        let result = this.situacoes.filter(obj => {
            return obj.value == key
        })

        if(result.length > 0){
            return result[0].label;
        }

        return '---';
    };

    carregaSituacoes = async (inputValue) => {
        if(inputValue){
            return this.situacoes.filter((el) => el.label.toLowerCase().includes(inputValue.toLowerCase()));
        }

        return this.situacoes;
    };

    criarSala = () => {
        
        const { agendamento_id, data_agendamento } = this.state;
        const MySwal = withReactContent(Swal)
    
        // Verifica se já temos o ID do agendamento
        if (!agendamento_id) {
            MySwal.fire({
                icon: 'error',
                title: 'Atenção',
                html: 'Agendamento não encontrado'
            });
            return;
        }
    
        let dataAgendamento = new Date(data_agendamento);
        dataAgendamento.setDate(dataAgendamento.getDate() + 2);
        const dataAgendamentoFormatada = dataAgendamento.toISOString().split('T')[0]; // Formato YYYY-MM-DD
    
        this.setState({ loading: true });
    
        api.post('/meetings/', {
            agendamento_id: agendamento_id,
            minutos_expiracao: 3600
        })
        .then(response => {
            // Atualiza o estado com os dados da sala, supondo que esses dados venham na resposta
            this.setState({
                meeting_guest_url: response.data.whereby_sala_url,
                meeting_host_url: response.data.whereby_sala_host_url,
                meeting_room_id: response.whereby_sala_id,
                loading: false
            });
    
            
            MySwal.fire({
                title: 'Sucesso',
                html: 'Sala Criada com sucesso!',
                icon: 'success',
            });
            
        })
        .catch(error => {
            MySwal.fire({
                icon: 'error',
                title: 'Atenção',
                html: 'Houve um erro ao criar a sala, tente novamente'
            });
            this.setState({ loading: false });
        });
    };


    carregaClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: (cliente.dados_pessoa.razao_social) ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})` : cliente.dados_pessoa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        if(!this.state.cliente_id) {
            return [];
        }
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosAgendamento" id="tabs-agendamento" className="aditus-tabs">
                    <Tab eventKey="dadosAgendamento" title="Dados do agendamento">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <Row>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data de Solicitação</Form.Label>
                                                <Form.Control type="datetime-local" name="data_solicitacao" required placeholder="Data de Solicitação" value={this.state.data_solicitacao} onChange={this.handleChange} />
                                                <Form.Text id="formDataSolicitacaoHelpBlock" className="text-danger">{this.state.dataSolicitacaoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data do agendamento</Form.Label>
                                                <Form.Control type="datetime-local" name="data_agendamento" required placeholder="Data do agendamento" value={this.state.data_agendamento} onChange={this.handleChange} />    
                                                <Form.Text id="formDataAgendamentoHelpBlock" className="text-danger">{this.state.dataAgendamentoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {/*<Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data da liberação</Form.Label>
                                                <Form.Control type="datetime-local" name="data_liberacao" placeholder="Data da liberação" value={this.state.data_liberacao} onChange={this.handleChange} />    
                                                <Form.Text id="formDataLiberacaoHelpBlock" className="text-danger">{this.state.dataLiberacaoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data da realização</Form.Label>
                                                <Form.Control type="datetime-local" name="data_realizacao" placeholder="Data da realização" value={this.state.data_realizacao} onChange={this.handleChange} />    
                                                <Form.Text id="formDataRealizacaoHelpBlock" className="text-danger">{this.state.dataRealizacaoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>*/}

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cliente</Form.Label>
                                                <AsyncSelect
                                                    required
                                                    cacheOptions
                                                    loadOptions={this.carregaClientes}
                                                    defaultOptions
                                                    name="cliente_id"
                                                    placeholder={'Buscar cliente...'}
                                                    noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                    onChange={e => this.handleChange(e, 'cliente_id')}
                                                    value={this.state.cliente_id ? { value: this.state.cliente_id, label: this.state.cliente_nome } : null}
                                                />
                                                <Form.Text id="clienteHelper" className="text-danger">{this.state.clienteHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>

                                        {this.state.cliente_id && (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Programa</Form.Label>
                                                <AsyncSelect
                                                    required
                                                    cacheOptions
                                                    loadOptions={this.carregaProgramas}
                                                    defaultOptions
                                                    name="programa_id"
                                                    placeholder={'Buscar programa...'}
                                                    noOptionsMessage={() => "Nenhum programa encontrado"}
                                                    onChange={e => this.handleChange(e, 'programa_id')}
                                                    value={this.state.programa_id ? { value: this.state.programa_id, label: this.state.programa_nome } : null}
                                                />
                                                <Form.Text id="programaHelper" className="text-danger">{this.state.programaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        )}

                                        {this.state.programa_id && (
                                            <>
                                                {/*<Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Mentoria?</Form.Label>
                                                        <div>
                                                            <Button 
                                                                variant={this.state.mentoria ? "success" : "outline-secondary"}
                                                                onClick={() => this.handleChange(true, 'mentoria')}>
                                                                Sim
                                                            </Button>
                                                            {' '}
                                                            <Button 
                                                                variant={!this.state.mentoria ? "danger" : "outline-secondary"}
                                                                onClick={() => this.handleChange(false, 'mentoria')}>
                                                                Não
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Possui chamada de Vídeo?</Form.Label>
                                                        <div>
                                                            <Button 
                                                                variant={this.state.possui_chamada_video ? "success" : "outline-secondary"}
                                                                onClick={() => this.setState({ possui_chamada_video: true })}>
                                                                Sim
                                                            </Button>
                                                            {' '}
                                                            <Button 
                                                                variant={!this.state.possui_chamada_video ? "danger" : "outline-secondary"}
                                                                onClick={() => this.setState({ possui_chamada_video: false })}>
                                                                Não
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>*/}

                                                {this.state.mentoria ? (
                                                    <>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Mentor</Form.Label>
                                                                <AsyncSelect
                                                                    key={`mentor-${this.state.key}`}  // Adicione a chave única aqui
                                                                    required
                                                                    cacheOptions
                                                                    loadOptions={this.carregaMentores}
                                                                    defaultOptions
                                                                    name="prestador_id"
                                                                    placeholder='Selecionar mentor...'
                                                                    noOptionsMessage={() => "Nenhum resultado encontrado"}
                                                                    onChange={e => this.handleChange(e, 'prestador_id')}
                                                                    value={this.state.prestador_id ? { value: this.state.prestador_id, label: this.state.prestador_nome } : null}
                                                                />
                                                                <Form.Text id="PrestadorIdHelper" className="text-danger">{this.state.PrestadorIdHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Mentorado</Form.Label>
                                                                <AsyncSelect
                                                                    key={`mentorado-${this.state.key}`}  // Adicione a chave única aqui
                                                                    required
                                                                    cacheOptions
                                                                    loadOptions={this.carregaMentorados}
                                                                    defaultOptions
                                                                    name="mentorado_id"
                                                                    placeholder='Selecionar mentorado...'
                                                                    noOptionsMessage={() => "Nenhum resultado encontrado"}
                                                                    onChange={e => this.handleChange(e, 'mentorado_id')}
                                                                    value={this.state.mentorado_id ? { value: this.state.mentorado_id, label: this.state.mentorado_nome } : null}
                                                                />
                                                                <Form.Text id="formMentoradoIdHelpBlock" className="text-danger">{this.state.MentoradoIdHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Prestador</Form.Label>
                                                                <AsyncSelect
                                                                    key={`prestador-${this.state.key}`}  // Adicione a chave única aqui
                                                                    required
                                                                    cacheOptions
                                                                    loadOptions={this.carregaPrestadores}
                                                                    defaultOptions
                                                                    name="prestador_id"
                                                                    placeholder='Selecionar prestador'
                                                                    noOptionsMessage={() => "Nenhum resultado encontrado"}
                                                                    onChange={e => this.handleChange(e, 'prestador_id')}
                                                                    value={this.state.prestador_id ? { value: this.state.prestador_id, label: this.state.prestador_nome } : null}
                                                                />
                                                                <Form.Text id="PrestadorIdHelper" className="text-danger">{this.state.PrestadorIdHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Beneficiário</Form.Label>
                                                                <AsyncSelect
                                                                    key={`beneficiario-${this.state.key}`}  // Adicione a chave única aqui
                                                                    required
                                                                    cacheOptions
                                                                    loadOptions={this.carregaBeneficiarios}
                                                                    defaultOptions
                                                                    name="beneficiario_id"
                                                                    placeholder='Selecionar beneficiário'
                                                                    noOptionsMessage={() => "Nenhum resultado encontrado"}
                                                                    onChange={e => this.handleChange(e, 'beneficiario_id')}
                                                                    value={this.state.beneficiario_id ? { value: this.state.beneficiario_id, label: this.state.beneficiario_nome } : null}
                                                                />
                                                                <Form.Text id="formBeneficiarioIdHelpBlock" className="text-danger">{this.state.BeneficiarioIdHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                )}

                                                
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Serviço/Procedimento</Form.Label>
                                                        <AsyncSelect
                                                            required
                                                            cacheOptions
                                                            loadOptions={this.carregaServicoProcedimento}
                                                            defaultOptions
                                                            name="servico_procedimento_id"
                                                            placeholder="Buscar serviço/procedimento..."
                                                            noOptionsMessage={() => "Nenhum serviço/procedimento encontrado"}
                                                            onChange={e => this.handleChange(e, 'servico_procedimento_id')}
                                                            value={this.state.servico_procedimento_id ? { value: this.state.servico_procedimento_id, label: this.state.servico_procedimento_nome } : null}
                                                        />
                                                        <Form.Text id="formServicoProcedimentoIdHelpBlock" className="text-danger">{this.state.ServicoProcedimentoIdHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Valor</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="valor"
                                                            value={this.state.valor} 
                                                            required
                                                            onChange={e => this.handleChange(e, 'valor')}
                                                        />
                                                        <Form.Text id="formValorHelpBlock" className="text-danger">{this.state.ValorHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                {/*<Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>NFE</Form.Label>
                                                        <Form.Control type="text" name="nfe" placeholder="NFE" value={this.state.nfe} onChange={this.handleChange} />    
                                                        <Form.Text id="formNfeHelpBlock" className="text-danger">{this.state.NfeHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Situação</Form.Label>
                                                        <AsyncSelect
                                                            required
                                                            cacheOptions
                                                            loadOptions={this.carregaSituacoes}
                                                            defaultOptions
                                                            name="situacao"
                                                            placeholder="Buscar situação..."
                                                            noOptionsMessage={() => "Nenhuma situação encontrada"}
                                                            onChange={e => this.handleChange(e, 'situacao')}
                                                            value={this.state.situacao ? { value: this.state.situacao, label: this.state.situacao_nome } : null}
                                                        />
                                                        <Form.Text id="formSituacaoHelpBlock" className="text-danger">{this.state.SituacaoHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>*/}
                                            </>
                                        )}
                                        
                                    </Row>

                                    {this.state.meeting_room_id ? (
                                        <Alert variant="success">Sala de vídeo conferência criada: {this.state.meeting_room_id}</Alert>
                                    ) : (this.state.possui_chamada_video && this.state.agendamento_id) ? (
                                        <Row>
                                            <Col sm={4} xs={12}>
                                                <Button variant="secondary" onClick={this.criarSala}>{this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Criar Sala de Vídeo Conferência'} </Button>
                                            </Col>
                                        </Row>
                                    ) : null}

                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button type="submit" className="btn btn-first mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar'}                                       
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>                    
                </Tabs>
            </div>
        )
    }
}

export default withRouter(AgendamentosEdit);
